<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
  <div class="navbar navbar-light" style="width: 100%;display: flex; justify-content: center; align-items: center">
    <div class="navbar-brand">

      <img src="../../../assets/images/app_logo_with_icon1.png" width="180" height="50" class="d-inline-block align-top ml-1 mr-1"
           alt="">
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent, #menubar"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
            >
      <i class="fa fa-ellipsis-v"></i>
    </button>

  </div>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
  <div class="container-fluid" #main [style.padding-top.px]="80">
    <div class="col-sm-12 px-0 align-self-end">
      <!-- <div class="row align-items-center">
        <div class="col-sm-10">
          <h5 class="light-header bold">
            {{ 'LANDING.LBL_TITLE' | translate}}
          </h5>
        </div>
      </div>
      <hr class="mt-0 mb-3" /> -->
    </div>
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-6">
        <div class="pt-3">
          <!-- <div class="container border rounded p-3 bold"> -->

        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <!-- Account details card-->
        <div class="card mb-4">
          <div class="card-header" style="font-weight: bold">This Privacy Policy is effective 21st February 2024.</div>
          <div class="card-body">
            <form>
              <div class="row gx-3 mb-3" style="margin-left: 4px; margin-right: 4px">

                <p style="text-align: justify">


                  Thank you for choosing to use Ergo-Flex Technologies (the "Application"). This Privacy Policy outlines our practices regarding the collection, use, and disclosure of personal information when you use our Application. By using the Application, you agree to the terms outlined in this Privacy Policy.
                </p>

                <h5 style="padding-left:2em;" class="w-100">
                  1. Information We Collect:
                </h5>

                <ul style="margin-left: 4rem">
                  <li>Personal Information: We may collect personal information, such as your name, email address, and other contact details when you register for an account.</li>
                  <li>Usage Information: We may collect information about how you use the Application, such as your interactions with the features and functionalities offered.</li>
                  <li>Device Information: We may collect information about your device, including the device type, operating system, and unique device identifiers.</li>
                </ul>



                <h5 style="padding-left:2em;" class="w-100">
                  2. How We Use Your Information:
                </h5>

                <ul style="margin-left: 4rem">
                  <li>We may use the information collected to provide and improve the functionality of the Application, personalize your experience, and communicate with you regarding updates or changes to the Application.</li>
                  <li>We may use your information to analyze user trends and preferences, optimize the performance of the Application, and detect and prevent fraud or security issues.</li>
                </ul>

                <h5 style="padding-left:2em;" class="w-100">
                  3. Sharing of Information:
                </h5>

                <ul style="margin-left: 4rem">
                  <li>We may share your personal information with third-party service providers who assist us in providing and maintaining the Application. These service providers are contractually obligated to use your information only for the purposes specified by us.</li>
                  <li>We may disclose your information if required by law or to protect our rights, property, or safety, or the rights, property, or safety of others.</li>
                </ul>

                <h5 style="padding-left:2em;" class="w-100">
                  4. Data Retention:
                </h5>
                <ul style="margin-left: 4rem">
                  <li>We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.</li>
                </ul>



                <h5 style="padding-left:2em;"  class="  w-100">
                  5. Security:
                </h5>
                <ul style="margin-left: 4rem">
                  <li>We take appropriate measures to safeguard your personal information and protect it from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security of your information.</li>
                </ul>
                <h5 style="padding-left:2em;" class="w-100">
                  6. Changes to the Privacy Policy:
                </h5>
                <ul style="margin-left: 4rem">
                  <li>We reserve the right to update or modify this Privacy Policy at any time. We will notify you of any changes by posting the revised Privacy Policy on our website. Your continued use of the Application after the changes will constitute your acceptance of the revised Privacy Policy.</li>
                </ul>

                <div class="row w-100">
                  <div class="col-12">
                    <h5 style="padding-left:2em;"  >
                      7. Contact Us:
                    </h5>

                  </div>
                </div>

                <div>
                  <ul style="margin-left: 4rem">
                    <li>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at <a href="mailto: service@ergoflextechnologies.com">service@ergoflextechnologies.com</a></li>
                  </ul>
                </div>

                <p style="text-align: justify">

                  By using the Application, you acknowledge that you have read and understood this Privacy Policy. If you do not agree with the terms outlined in this Privacy Policy, please do not use the Application.
                </p>
                <p>
                  Thank you for your trust in Ergo-Flex Technologies Application.

                </p>
                <div style="width: 100%">
                  <p>
                    Ergo-Flex Technologies.
                  </p>
                </div>




              </div>
            </form>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
